<template lang="html">

  <div v-if="data.length > 0" class="encuestas-view" id="encuestas">

    <h2>
        {{ $t('header.informes_encuestas_pendientes') }}
    </h2>

    <section class="listado-encuestas container row-between" >
      <template v-for="(encuesta, key) in data.slice(0, 3)">
        <encuesta-el :prop="encuesta" :key="key"></encuesta-el>
      </template>
      <arrow-link v-if="data && data.length > 3" class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.encuestas')"></arrow-link>
    </section>

  </div>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';
  import arrowLink from '@/components/parts/icons/arrow-link';
  import encuestaEl from '@/components/parts/encuesta-el';

  export default  {
    name: 'modulo-encuestas',
    mounted(){

      if(!!this.userType){
        this.requestEncuestas(this.userType);
      }

      if(this.$route.hash == "#encuestas"){
        let top = $("#encuestas").offset().top;

        $("html, body").animate({scrollTop: top},1000);

      }


    },
    computed : {
      ...mapGetters({
        data : 'getEncuestas',
        colors : 'basicColors',
        style : 'getStyles',
        userType : 'getUserType'
      })
    },
    components : {
      'encuesta-el': encuestaEl,
      'arrow-link': arrowLink
    },
    methods : {
      ...mapActions(['requestEncuestas'])
    }
  }
</script>

<style scoped lang="scss">

  .encuestas-view{
    padding: 50px 0;
    width: 100%;
    display: inline-block;
    padding-bottom: 0;
    margin-bottom: 100px;
  }

  h2{
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    margin-bottom: 25px;
  }

  .listado-encuestas{
    width: 100%;
    max-width: 800px;
    .arrow-link {
      margin-top: 15px;
      color: #003865;
    }
  }

  .no-encuestas{
    width: 100%;
    text-align: center;
  }


  @media screen and (max-width: 767px){

    .encuestas-view{
      padding: 25px 0;
      width: 100%;
      display: inline-block;
    }

  }

  @media screen and (max-width: 500px){
    h2{
      font-size: 24px;
      margin-bottom: 15px;
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/views/home/modulo-encuestas.vue